export default "__VITE_ASSET__CTOajFhq__"